module.exports = __webpack_public_path__ + "img/exception_500.1a6a5510.png";